
import React from 'react';
import { Button } from '@/components/ui/button';
import { Slider } from '@/components/ui/slider';
import { Sparkles } from 'lucide-react';
import RecentContributions from './RecentContributions';
import { ShrineOffering } from '@/hooks/use-shrine';

interface ShrineContentProps {
  totalOfferings: number;
  contribution: number;
  onContributionChange: (value: number) => void;
  onContribute: () => void;
  recentOfferings: ShrineOffering[];
}

const ShrineContent = ({
  totalOfferings,
  contribution,
  onContributionChange,
  onContribute,
  recentOfferings
}: ShrineContentProps) => {
  return (
    <div className="relative z-10 w-full max-w-md mx-4 rounded-xl p-6 space-y-6 backdrop-blur-md bg-black/30 border border-cyan-600/30">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-cyan-300 mb-2 uppercase tracking-widest">THE SHRINE</h1>
        <p className="text-cyan-500 mb-4 text-sm">Your contribution will be considered...</p>
      </div>

      <div className="flex justify-center items-center space-x-4">
        <Sparkles className="text-cyan-400 w-10 h-10" />
        <span className="text-3xl font-bold text-cyan-300">
          {totalOfferings}
        </span>
      </div>

      <div className="space-y-4">
        <div className="flex items-center space-x-4">
          <Slider
            defaultValue={[contribution]}
            min={10}
            max={500}
            step={10}
            onValueChange={(value) => onContributionChange(value[0])}
            className="flex-grow"
          />
          <span className="text-cyan-300 font-bold">{contribution} ♔</span>
        </div>
        
        <Button 
          onClick={onContribute} 
          className="w-full bg-cyan-600 hover:bg-cyan-700 text-white"
        >
          Offer to the Shrine
        </Button>
      </div>

      <RecentContributions offerings={recentOfferings} />
    </div>
  );
};

export default ShrineContent;
